import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { projectsStagingManageDialog } from "Store/Actions";
import { selectIgnoredValues, selectShowIgnoredValuesDialog } from "Store/Selectors/Staging";
import { IUseManageIgnoredSourceData } from "./IUseManageIgnoredSourceData";

export function useManageIgnoredSourceData(): IUseManageIgnoredSourceData {
  const dispatch = useDispatch();
  const showDialog = useSelector(selectShowIgnoredValuesDialog);
  const ignoredSourceData = useSelector(selectIgnoredValues);
  const onDismiss = useCallback(() => dispatch(projectsStagingManageDialog(false)), [dispatch]);

  return {
    showDialog,
    ignoredSourceData,
    onDismiss
  };
}
